import * as React from "react";

import * as Classes from "src/mpd-library";

import * as classNames from "classnames";

import { CSSTransition, TransitionGroup } from "react-transition-group";

import { IProps } from "@blueprintjs/core";

import { IMPDPanel } from "./panel-props";

import { MPDPanelView } from "./panel-view";

export interface IMPDPanelStackProps extends IProps {
  /*
  * The transition duration of the panel stack
  */
  transitionDuration?: number;

  /**
   * Callback invoked when the user presses the back button or a panel invokes
   * the `closePanel()` injected prop method.
   */
  onClose?: (removedPanel: IMPDPanel) => void;

  /**
   * Callback invoked when a panel invokes the `openPanel(panel)` injected
   * prop method.
   */
  onOpen?: (addedPanel: IMPDPanel) => void;

  /**
   * A way to overwrite the current stack with given panelStack array
   */
  panelStack: Array<IMPDPanel>;
}

export interface IMPDPanelStackState {
  /** Whether the stack is currently animating the push or pop of a panel. */
  direction: "push" | "pop";

  /** The current stack of panels. The first panel in the stack will be displayed. */
  stack: Array<IMPDPanel>;
}

export class MPDPanelStack extends React.PureComponent<
  IMPDPanelStackProps,
  IMPDPanelStackState
> {
  public state: IMPDPanelStackState = {
    direction: "push",
    stack: [this.props.panelStack[0]]
  };

  public render() {
    const classes = classNames(
      Classes.PANEL_STACK,
      `${Classes.PANEL_STACK}-${this.state.direction}`,
      this.props.className
    );
    return (
      <TransitionGroup className={classes} component="div">
        {this.renderCurrentPanel()}
      </TransitionGroup>
    );
  }

  public componentWillReceiveProps({ panelStack }: IMPDPanelStackProps) {
    const { stack } = this.state;
    if (panelStack && panelStack.slice() !== stack.slice()) {
      this.setState({ stack: panelStack });
    }
  }

  private renderCurrentPanel() {
    const { stack } = this.state;
    const { transitionDuration } = this.props;
    if (stack.length === 0) {
      return <div />;
    }
    const [activePanel] = stack;
    return (
      <CSSTransition
        classNames={Classes.PANEL_STACK}
        key={stack.length}
        timeout={transitionDuration ? transitionDuration : 0}
      >
        <MPDPanelView
          onClose={this.handlePanelClose}
          onOpen={this.handlePanelOpen}
          panel={activePanel}
        />
      </CSSTransition>
    );
  }

  private handlePanelClose = (panel: IMPDPanel) => {
    const { stack } = this.state;
    const { onClose } = this.props;
    // only remove this panel if it is at the top and not the only one.
    if (stack[0] !== panel || stack.length <= 1) {
      return;
    }
    // safeInvoke(this.props.onClose, panel);
    if (onClose) {
      onClose(panel);
    }
    this.setState(state => ({
      direction: "pop",
      stack: state.stack.filter(p => p !== panel)
    }));
  };

  private handlePanelOpen = (panel: IMPDPanel) => {
    const { onOpen } = this.props;
    // safeInvoke(this.props.onOpen, panel);
    if (onOpen) {
      onOpen(panel);
    }
    this.setState(state => ({
      direction: "push",
      stack: [panel, ...state.stack]
    }));
  };
}



// WEBPACK FOOTER //
// ./src/mpd-library/panel-stack/panel-stack.tsx